/**
 * TanStack Query hooks for `igaming-brand-level-reporting-isolation`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingBrandLevelReportingIsolationQueryKeys,
	type CreateIgamingBrandLevelReportingIsolationBody,
	type ListIgamingBrandLevelReportingIsolationResponse,
	type IgamingBrandLevelReportingIsolationRow,
} from "./api";

export function useIgamingBrandLevelReportingIsolationList(): UseQueryResult<ListIgamingBrandLevelReportingIsolationResponse, Error> {
	return useQuery({
		queryKey: igamingBrandLevelReportingIsolationQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingBrandLevelReportingIsolationCreate(): UseMutationResult<IgamingBrandLevelReportingIsolationRow, Error, CreateIgamingBrandLevelReportingIsolationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBrandLevelReportingIsolationQueryKeys.all });
		},
	});
}

export function useIgamingBrandLevelReportingIsolationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBrandLevelReportingIsolationQueryKeys.all });
		},
	});
}
